class DD0ShippingEta extends HTMLElement {
  connectedCallback() {
    const days = parseInt(this.dataset.days, 10) || 3;
    const locale = this.dataset.locale || 'es';
    const format = this.dataset.format || 'long';
    const target = this.querySelector('[data-text-target]');
    const tmpl = this.dataset.template || '';
    if (!target || !tmpl) return;

    const future = new Date();
    future.setDate(future.getDate() + days);

    const opts = format === 'long'
      ? { day: 'numeric', month: 'long' }
      : { day: '2-digit', month: '2-digit' };

    let dateStr;
    try {
      dateStr = future.toLocaleDateString(locale, opts);
    } catch (e) {
      dateStr = future.toLocaleDateString('en', opts);
    }

    target.innerHTML = tmpl.replace('[date]', `<b data-date>${dateStr}</b>`);
  }
}

if (!customElements.get('dd0-shipping-eta')) {
  customElements.define('dd0-shipping-eta', DD0ShippingEta);
}
